import { QueryFeature } from '../../../config/queryClient';

enum QueryKey {
  ClientAssociatedProfiles = 'ClientAssociatedProfiles',
  Localize = 'Localize',
}

export const queryKeys = {
  clientAssociatedProfiles: (clientId: string, includeValue: boolean) => [
    QueryFeature.TopNav,
    QueryKey.ClientAssociatedProfiles,
    clientId,
    includeValue,
  ],

  localize: (clientId: string) => [QueryFeature.TopNav, QueryKey.Localize, clientId],
};
